import './style.css'

export default class NaturalCapital {
    static selector = '.natural-capital'

    constructor(block) {
        this.block = block;
    }
}
